import type { PropsWithChildren } from "react";
import { StyledWrapper, StyledCloseButton } from "./styles";
import type { BaseActivatedPanelProps } from "./types";

function BaseActivatedPanel(props: PropsWithChildren<BaseActivatedPanelProps>) {
    const { className, children, onDeactivate } = props;

    return (
        <StyledWrapper className={className}>
            {children}
            <StyledCloseButton
                type="flat"
                iconSize="14px"
                iconName="close"
                onClick={onDeactivate}
                dataAutomation="table-actions-panel.close-button"
            />
        </StyledWrapper>
    );
}

export default BaseActivatedPanel;
